import { SingleSelectionOption } from '../interfaces'
export interface CodeSelectorOption {
  name: string
  label: string
  value: string
  buttons: SingleSelectionOption[]
}
export const codeSelectorDefaultOptions: CodeSelectorOption[] = [
  {
    name: 'integration',
    label: 'Integration:',
    value: 'standard',
    buttons: [
      {
        label: 'PayPal',
        value: 'standard',
      },
      {
        label: 'Expanded',
        value: 'advanced',
      },
    ],
  },
  {
    name: 'frontend',
    label: 'Front end language:',
    value: 'html',
    buttons: [
      {
        label: 'HTML',
        value: 'html',
      },
      {
        label: 'React',
        value: 'react',
      },
      // {
      //   label: 'Angular',
      //   value: 'angular',
      // },
    ],
  },
  {
    name: 'backend',
    label: 'Back end language:',
    value: 'nodejs',
    buttons: [
      {
        label: 'Node JS',
        value: 'nodejs',
      },
      // {
      //   conditions: [
      //     {
      //       option: 'integration',
      //       value: 'advanced',
      //     },
      //   ],
      //   label: 'Java',
      //   value: 'java',
      // },
      // {
      //   label: 'Python',
      //   value: 'python',
      // },
      // {
      //   label: 'PHP',
      //   value: 'php',
      // },
    ],
  },
]
